import { NavMenuKeys } from '@/routes/navMenu';
import { lazyImport } from '@/utils/lazyImport';
import React from 'react';
const {
  Page
} = lazyImport(() => import('../index'), 'Page'); // 该页面的路由，以及所属那个模块

export const routes = [{
  name: '用户关系网',
  path: '/member/relation',
  element: /*#__PURE__*/React.createElement(Page, null),
  module: NavMenuKeys.Operation,
  layout: 'BasicLayout',
  enable: false,
  order: 10
}];